import { USER_ID_INTERNAL_REGEX } from './users';

const loginIdValidator = (t, isInternalLoginAllowed) => (input) => {
    let err = null;
    if (!isInternalLoginAllowed && input.match(USER_ID_INTERNAL_REGEX) !== null) {
        err = t('login.validation.login-id-internal-user');
    }
    return err;
};

export default loginIdValidator;
